<script setup lang="ts">
import { computed, ref } from 'vue';

const props = withDefaults(defineProps<{
  show?: boolean;
}>(), {
  show: true
});

const isVisible = ref(props.show);

const showClass = computed(() => props.show ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]');

const handleTransitionEnd = (): void => {
  if (!props.show) {
    isVisible.value = false;
  }
};

const handleTransitionStart = (): void => {
  if (props.show) {
    isVisible.value = true;
  }
};
</script>

<template>
  <div
    class="grid transition-all duration-300 ease-in-out"
    :class="showClass"
    @transitionstart="handleTransitionStart"
    @transitionend="handleTransitionEnd"
  >
    <div class="overflow-hidden">
      <slot v-if="isVisible" />
    </div>
  </div>
</template>
